import { useContext } from 'react';
import UserContext from '../../../../shared-components/contexts/UserContext';
import { Role } from '../../../../shared-types/Roles';
import { IUserRole } from '../Interfaces/IUserRole';

export function GetUserRoles() {
  const user = useContext(UserContext);
  let roles = [
    {
      name: 'Student',
      value: Role.Student,
    },
    {
      name: 'Peer Advisor',
      value: Role.PeerAdvisor,
    },
    {
      name: 'Advisor',
      value: Role.Advisor,
    },
    {
      name: 'Generalist',
      value: Role.Generalist,
    },
    {
      name: 'Executive',
      value: Role.Executive,
    },
    {
      name: 'Administrator',
      value: Role.Administrator,
    },
  ] as IUserRole[];

  if (user.isSupport) {
    roles.push({
      name: 'Support',
      value: Role.Support,
    });
  }

  return roles;
}
